var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"py-4"},[_c('b-breadcrumb',{attrs:{"items":_vm.breadcrumbs}}),_c('h1',{staticClass:"mb-3"},[_vm._v("Novi izveštaj")]),_c('ReportForm',{attrs:{"report":_vm.report}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }